export default __webpack_public_path__ + "static/media/service5.218551f2.jpg";